var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout hom-layout"},_vm._l((_vm.componentsData),function(item,index){return _c('div',{key:index,staticClass:"list-group-item"},[_c(_vm.componentMap[_vm.terminal - 1].get(item.type),{tag:"component",attrs:{"componentContent":item.componentContent,"terminal":_vm.terminal}})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7df5b83d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/canvasShow/canvasShowPage.vue
// module id = null
// module chunks = 